import React, {Component} from 'react';
import './item-modality.scss';

export default class ItemModality extends Component {


    render() {
        return <a href={this.props.url} className={`body-item-mod cur-p ${this.props.clasCustA}`}>
            <div className={`cnt-item-mod ${this.props.size === "x2" ? "x--2 ab-none" :""} ${this.props.clasCust}`}>
                <h2 className={`title-mod ${this.props.size === "x2" ? "m-md col-thr2 fw-b" :""}`}>{this.props.title}</h2>
                <img className={`img-mod ${this.props.size === "x2" ? "ximg--2" :""}`} src={this.props.imageMod.default}  width={"3em"} alt=""/>
            </div>
        </a>
    }
}
